import { Link } from 'react-router-dom';
import Icon from 'components/Icon';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="logo">
              <div className="logo-box"><Icon name="logo" size={18} /></div>
              <span className="logo-name">Devlayar</span>
            </div>
            <p>Free online tools for everyone. PDF tools, image tools, and more. No signup required. Fast and simple.</p>
          </div>
          <div className="footer-sec">
            <h4>PDF Tools</h4>
            <ul>
              <li><Link to="/tools/pdf/merge">Merge PDF</Link></li>
              <li><Link to="/tools/pdf/split">Split PDF</Link></li>
              <li><Link to="/tools/pdf/compress">PDF Compressor</Link></li>
              <li><Link to="/tools/pdf/to-word">PDF to Word</Link></li>
              <li><Link to="/tools/pdf/to-jpg">PDF to JPG</Link></li>
              <li><Link to="/tools/pdf/image-to-pdf">Image to PDF</Link></li>
            </ul>
          </div>
          <div className="footer-sec">
            <h4>Image Tools</h4>
            <ul>
              <li><Link to="/tools/image/jpg-to-png">JPG to PNG</Link></li>
              <li><Link to="/tools/image/png-to-jpg">PNG to JPG</Link></li>
              <li><Link to="/tools/image/resize">Image Resize</Link></li>
              <li><Link to="/tools/image/compress">Image Compressor</Link></li>
            
            </ul>
          </div>
          <div className="footer-sec">
            <h4>More Tools</h4>
            <ul>
              <li><Link to="/tools/text/word-counter">Word Counter</Link></li>
              <li><Link to="/tools/text/case-converter">Case Converter</Link></li>
              <li><Link to="/tools/utility/qr-code">QR Code Generator</Link></li>
              <li><Link to="/tools/utility/resume-builder">Resume Builder</Link></li>
              <li><Link to="/blog">Blog</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-links-row">
          <a href="/about">About</a>
          <a href="/contact">Contact</a>
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms</a>
          <a href="/faq">FAQ</a>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Devlayar. All rights reserved.</p>
          <p style={{ color:'#64748b', fontSize:12 }}>Developed by <strong style={{ color:'#94a3b8' }}>Ethoss Technologies</strong></p>
        </div>
      </div>
    </footer>
  );
}